// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable selector-class-pattern -- 
Происходит расширение размерной сетки консты и удаление ненужных элементов */
.Responses__container___Cd2Ng {
    container: responses / size;
    display: flex;

    width: 100%;
    height: 100%;
    padding-inline: var(--space-xs);
}

.Responses_size_s {
    --title-size: var(--size-text-l);
    --description-size: var(--size-text-xs);
    --image-width: 20rem;
}

.Responses__response___PHf07 {
    flex-direction: column;

    & .Responses-Title,
    .Responses-ButtonsWrapper {
        display: none;
    }
}

@container responses (height < 25rem) {
    div.Responses__response___PHf07 {
        flex-direction: row;
    }
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Responses/Responses.css"],"names":[],"mappings":"AAAA;4EAC4E;AAC5E;IACI,2BAA2B;IAC3B,aAAa;;IAEb,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,uCAAuC;IACvC,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;;IAEtB;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["/* stylelint-disable selector-class-pattern -- \nПроисходит расширение размерной сетки консты и удаление ненужных элементов */\n.container {\n    container: responses / size;\n    display: flex;\n\n    width: 100%;\n    height: 100%;\n    padding-inline: var(--space-xs);\n}\n\n:global(.Responses_size_s) {\n    --title-size: var(--size-text-l);\n    --description-size: var(--size-text-xs);\n    --image-width: 20rem;\n}\n\n.response {\n    flex-direction: column;\n\n    & :global(.Responses-Title),\n    :global(.Responses-ButtonsWrapper) {\n        display: none;\n    }\n}\n\n@container responses (height < 25rem) {\n    div.response {\n        flex-direction: row;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Responses__container___Cd2Ng`,
	"response": `Responses__response___PHf07`
};
export default ___CSS_LOADER_EXPORT___;
